import styled from 'styled-components/macro';

const BanWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  ${({ isBanned }) => isBanned && `
    opacity: 0.4;
  `}
`;

export default BanWrapper;
